import clsx from 'clsx';
import { forwardRef } from 'react';

const VARIANTS = {
  brand: 'btn-brand',
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  ghost: 'btn-ghost',
  outline: 'btn-outline',
  danger: 'btn bg-error-600 text-white hover:bg-error-700 shadow-md shadow-error-600/15 hover:-translate-y-0.5',
};

const SIZES = {
  sm: '!py-1.5 !px-2.5 text-[13px] rounded-md',
  md: '',
  lg: '!py-2.5 !px-4 text-sm',
};

const Button = forwardRef(function Button(
  {
    variant = 'brand',
    size = 'md',
    className,
    children,
    loading = false,
    disabled,
    as: Component = 'button',
    ...props
  },
  ref,
) {
  return (
    <Component
      ref={ref}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={clsx(VARIANTS[variant], SIZES[size], className)}
      {...props}
    >
      {loading && (
        <span
          className="h-3.5 w-3.5 shrink-0 rounded-full border-2 border-current/25 border-t-current animate-spin"
          aria-hidden
        />
      )}
      {children}
    </Component>
  );
});

export default Button;
